import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AnSKD = (props) => {
  const [skd_spl, setSkd_spl] = useState(
    props.leadData.skd_spl ? props.leadData.skd_spl : ""
  );
  const [skd_date_spl, setSkd_date_spl] = useState(
    props.leadData.skd_date_spl ? props.leadData.skd_date_spl : ""
  );
  const [skd_dg, setSkd_dg] = useState(
    props.leadData.skd_dg ? props.leadData.skd_dg : ""
  );
  const [skd_dg_add, setSkd_dg_add] = useState(
    props.leadData.skd_dg_add ? props.leadData.skd_dg_add : ""
  );
  const [skd_type, setSkd_type] = useState(
    props.leadData.skd_type ? props.leadData.skd_type : ""
  );
  const [skd_q1, setSkd_q1] = useState(
    props.leadData.skd_q1 ? props.leadData.skd_q1 : ""
  );
  const [skd_q2, setSkd_q2] = useState(
    props.leadData.skd_q2 ? props.leadData.skd_q2 : ""
  );
  const [skd_q3, setSkd_q3] = useState(
    props.leadData.skd_q3 ? props.leadData.skd_q3 : ""
  );
  const [skd_q4, setSkd_q4] = useState(
    props.leadData.skd_q4 ? props.leadData.skd_q4 : ""
  );
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const editLead = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        leadId: props.leadData.id,
        skd_spl: skd_spl,
        skd_date_spl: skd_date_spl,
        skd_dg: skd_dg,
        skd_dg_add: skd_dg_add,
        skd_type: skd_type,
        skd_q1: skd_q1,
        skd_q2: skd_q2,
        skd_q3: skd_q3,
        skd_q4: skd_q4,
        skd_an: "1",
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateLeadSKDAn", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano dane ankiety SKD: " + props.user,
        props.leadData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "lead",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Nie podano adnych danych ankiety",
      });
    }
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validatePayment = (e) => {
    if (skd_spl || skd_date_spl || skd_type || skd_dg) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className="mainContainerAddClientContact"
      style={{
        width: "50vw",
        top: "10vh",
        height: "80vh",
        overflowY: "scroll",
        paddingBottom: "20px",
      }}
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>Czy kredyt/pożyczka jest już spłacony?</label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_spl}
                onChange={(e) => {
                  setSkd_spl(e.target.value);
                }}
              >
                {!skd_spl ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"TAK"}>
                  TAK
                </option>
                <option key={1} value={"NIE"}>
                  NIE
                </option>
              </select>
            </div>
          </div>
          {skd_spl === "TAK" ? (
            <>
              <div className="inputBox">
                <div
                  style={{ width: "100%", minWidth: "100%" }}
                  className="inputCol_2"
                >
                  <label>Kiedy nastąpiła całkowita spłata?</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="date"
                    id="name"
                    name="name"
                    value={skd_date_spl}
                    onChange={(e) => {
                      setSkd_date_spl(e.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>
                Czy w momencie zawierania umowy kredytu któryś z kredytobiorców
                prowadził działalność gospodarczą?
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_dg}
                onChange={(e) => {
                  setSkd_dg(e.target.value);
                }}
              >
                {!skd_dg ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"TAK"}>
                  TAK
                </option>
                <option key={1} value={"NIE"}>
                  NIE
                </option>
              </select>
            </div>
          </div>
          {skd_dg === "TAK" ? (
            <>
              <div className="inputBox">
                <div
                  style={{ width: "100%", minWidth: "100%" }}
                  className="inputCol_2"
                >
                  <label>
                    Dodatkowe informacje o działalności gospodarczej. Czy ma
                    Pan/Pani dokumenty (np. potwierdzenie przelewów, umowę
                    zakupu samochodu, rachunki za remont) które wykażą, że te
                    środki były przeznaczone dla Pana, rodziny – a nie na firmę.
                  </label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={skd_dg_add}
                    onChange={(e) => {
                      setSkd_dg_add(e.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>
                Jaki jest to rodzaj kredytu/pożyczki (gotówkowy/hipoteczny)?
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_type}
                onChange={(e) => {
                  setSkd_type(e.target.value);
                }}
              >
                {!skd_type ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"hipoteczny"}>
                  hipoteczny
                </option>
                <option key={1} value={"gotówkowy"}>
                  gotówkowy
                </option>
              </select>
            </div>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>
                Na co przeznaczyła Pan/Pani otrzymaną kwotę pożyczki/kredytu?
              </label>
              <input
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_q1}
                onChange={(e) => {
                  setSkd_q1(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>
                Czy kredyt/pożyczka została zaciągnięta w celu spłacenia innych
                zobowiązań?
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_q2}
                onChange={(e) => {
                  setSkd_q2(e.target.value);
                }}
              >
                {!skd_q2 ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"TAK"}>
                  TAK
                </option>
                <option key={1} value={"NIE"}>
                  NIE
                </option>
              </select>
            </div>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>
                Czy którykolwiek ze spłaconych wcześniejszych kredytów został
                przeznaczony na działalność gospodarczą?
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_q3}
                onChange={(e) => {
                  setSkd_q3(e.target.value);
                }}
              >
                {!skd_q3 ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"TAK"}>
                  TAK
                </option>
                <option key={1} value={"NIE"}>
                  NIE
                </option>
              </select>
            </div>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "100%", minWidth: "100%" }}
              className="inputCol_2"
            >
              <label>Czy ogłosił Pan/Pani upadłość konsumencką?</label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={skd_q4}
                onChange={(e) => {
                  setSkd_q4(e.target.value);
                }}
              >
                {!skd_q4 ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"TAK"}>
                  TAK
                </option>
                <option key={1} value={"NIE"}>
                  NIE
                </option>
              </select>
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AnSKD;
